import React,{Component} from "react";
import SplitViewSideBarToggle from "../../SplitViewSideBarToggle";
import Icons from "../../Icons/Icons";
import ElementsToolbarTab from "./ElementsToolbarTab";
import BodyPropertiesTab from "./BodyPropertiesTab";
import ElementsProperties from "./ElementsProperties";

const tabList = [
  {
      tabName:'Layout',
      svgIcon:'HTMLLayout',
      tabId:'ElementsToolbar',
      component:ElementsToolbarTab
  },
  {
      tabName:'Body',
      svgIcon:'HTMLBody',
      tabId:'BodyProperties',
      component:BodyPropertiesTab
  },
  // {
  //     tabName:'Variables',
  //     svgIcon:'HTMLBody',
  //     tabId:'VariablesProperties',
  //     component:VariablesProperties
  // },
]
 
class SideBarContent extends Component {
  
    constructor(props) {
      super(props);
      this.state={
        activeTab:'ElementsToolbar'
      }      
    }
    changeHandler = (tabId)=>{
        this.setState({activeTab:tabId});
        this.props.updateTabDetails(tabId)
    }    
    render(){
        const {activeTab} = this.state;
        const {htmlContentItems,currentElement} = this.props;
        const tabIndex = tabList.findIndex((i=>i.tabId===activeTab));
        const ActiveTabComponent = tabList[tabIndex].component;
        //console.log('this.props.pageFrom====',this.props)
        return(
            <>
            <SplitViewSideBarToggle>
            <div className="filter_Header py-0 px-0 pr-2">
                <div className="d-flex border-bottom">
                    <ul className="nav nav-pills navcrm-primary nav-pills-no-bd">
                        {tabList.map((tab,tabIndex)=>{
                            const isActive  = (activeTab===tab.tabId)?'active':'';
                            return(
                                <li className="nav-item pl-2 cursor_pointer" key={tabIndex}>	
                                    <a 
                                        className={`nav-link ${isActive}`} 
                                        onClick={()=>this.changeHandler(tab.tabId)}> 
                                         <Icons iconType={tab.svgIcon} /> {tab.tabName} </a>
                                </li>
                            )
                        })}
                    </ul>
                </div>                    
            </div>
            <div className="filter_Body p-3 ">
                <div className="tab-content mt-2 mb-3" id="pills-with-icon-tabContent">
                    <ActiveTabComponent 
                        setDestinationItems={this.props.setDestinationItems}
                        htmlContentItems={htmlContentItems}
                        onChangePropertiesHandler={this.props.onChangePropertiesHandler}
                        setSelectedCurrentId={this.props.setSelectedCurrentId}
                        currentElement={currentElement}
                        pageFrom={this.props.pageFrom}                                            
                    />
                </div>
            </div>
            <div className="filter_Footer">
			</div>
          </SplitViewSideBarToggle>
          <ElementsProperties 
            setDestinationItems={this.props.setDestinationItems}
            htmlContentItems={htmlContentItems}
            onChangePropertiesHandler={this.props.onChangePropertiesHandler}
            setSelectedCurrentId={this.props.setSelectedCurrentId}
            currentElement={currentElement} 
            uploadFileRef={this.props.uploadFileRef}
            fileChangeHandler={this.props.fileChangeHandler}
            fileClickHandler={this.props.fileClickHandler}
            showFilterContent={this.props.showFilterContent}
            />
          </>
        )
    }
}  

export default SideBarContent;